import { render, staticRenderFns } from "./RecipeContainer.vue?vue&type=template&id=58e9cdaa&"
import script from "./RecipeContainer.vue?vue&type=script&lang=js&"
export * from "./RecipeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports